// LIBRERIE/IMPORTS
import React from "react";
import { useEffect, useState } from "react";

interface SubHeaderProps {
    title: string;
    isSeo: boolean;
}

const SubHeaderDefault: React.FC<SubHeaderProps> = ({ title, isSeo }) => {

    const [isTitleMonted, setIsTitleMonted] = useState(false);

    useEffect(() => {
        setIsTitleMonted(true);
    }, []);


    return (
        <div id="subHeader_default" className="bg-overlay-white-10">
            <div className="container-fluid w-90">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12">
                        {isSeo ? (
                            <h1 className={isTitleMonted ? "visibile" : ""}>{title}</h1>
                        ) : (
                            <h2 className="asH1Title">{title}</h2>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubHeaderDefault;